import React from 'react'
import AdminHome from '../../components/AdminHome/AdminHome'

function AdminHomePage() {
  return (
    <AdminHome></AdminHome>
  )
}

export default AdminHomePage